var serviceCarousel = {

    selectors: {
        elements: '[data-service-carousel]'
    },

    init: function() {
        var self = this,
            $elements = $( self.selectors.elements );

        self.hoverBlocks( $elements );

        $elements.slick( {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            mobileFirst: true,
            arrows: true,
            prevArrow: '<span><i class="icon-prev"></i></span>',
            nextArrow: '<span><i class="icon-next"></i></span>',
            rows: 0,
            centerMode: true,
            responsive: [ {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                    }
                }, {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                    }
                }, {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                    }
                }
            ]
        } );
    },

    hoverBlocks: function( $elements ) {
        var self = this;

        $elements.hover( function() {
            var $this = $( this );
            $this.addClass( 'hovered' );
        }, function() {
            var $this = $( this );
            $this.removeClass( 'hovered' );
        } );
    }

}

export {
    serviceCarousel
};
